import { createReducer, on } from '@ngrx/store';
import { IClientsState, initialClientsState } from './clients.state';
import { ClientsLoaded } from './clients.actions';

const setClients = (state: IClientsState, { clients }: { clients: IClientsState['clients'] }) => ({
  ...state,
  clients: clients
});


const _clientsReducer = createReducer<IClientsState>(
  initialClientsState,
  on(ClientsLoaded, setClients),
);

export function clientsReducer(state: IClientsState, action): IClientsState {
  return _clientsReducer(state, action);
}
